export default {
  "main": {
    "login": "Iniciar sesión",
    "email": "Email",
    "password": "Contraseña",
    "loginButton": "Inicia Sesión",
    "developedBy": "Desarrollado por",
    "error": "Usuario o contraseña incorrecta",
    "sessionExpired": "Su sesión ha finalizado automáticamente, por favor ingrese sus credenciales de acceso nuevamente.",
    "sessionExpiredTitle": "Sesión expirada",
    "next": "Siguiente",
    "emailRequired": "El email es requerido",
    "passwordRequired": "La contraseña es requerida",
    "validating": "Validando ...",
    "back": "Volver",
    "loading": "Cargando",
    "errorGetUrlSSO": "No se pudo obtener url de Auth0 para iniciar sesión. Comuníquese con la mesa de ayuda de Gauss Control.",
    "errorLoginlSSO": "No se pudo iniciar sesión con la autenticación de Auth0. Inténtelo nuevamente y si el problema persiste, comuníquese con la mesa de ayuda de Gauss Control.",
    "backToLogin": "Volver al inicio de sesión",
    "redirectTitleError": "Página no disponible",
    "redirectMessageError": "No se pudo realizar el redireccionamiento de la url consultada"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/spanish/login/index.js